module.exports = __webpack_public_path__ + "static/media/kim-kardashian.a91b2b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/kim-kardashian.jpg
// module id = 20
// module chunks = 0